import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../typings/theme';

export default makeStyles((theme: ITheme) => ({
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '10',
  },
  btnSave: {
    backgroundColor: 'gray',
    color: 'white',
  },
  btnPublish: {
    backgroundColor: '#78001b',
    color: 'white',
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginLeft: 0,
  },
  textField: {
    marginTop: 13,
  },
  marginDefault: {
    margin: theme.spacing(0),
  },
  marginText: {
    fontSize: 12, marginTop: 4, marginLeft: theme.spacing(1),
  },
  labelCenter: {
    fontSize: 10,
    marginTop: 15,
    textAlign: 'center',
  },
}));
